export default "__VITE_ASSET__BE$rU1Sv__"